export default __webpack_public_path__ + "static/media/loader.5ea65d80.png";